export default function (state = null, action) {
  switch (action.type) {
    case 'FETCH_PREVIEW_INVOICE_SUCCESS':
      return action.response

    case 'LOGOUT':
      return null

    default:
      return state
  }
}
